import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import ListingTable from './ListingTable';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { useGradingGroupListingState, buildGradingListParams } from './GradingListionProvider';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as action from '../Store/Pom.action';
import * as userAction from '../../../UserSetting/store/User.action';
import { checkArray } from '../../../../Components/helper';
import GradingFilter from './GradingFilter';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import '../Pom.css';
import PomTabs from '../PomTabs';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';

function GradingListing() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { gradingListingState, setgradingListing, GradingAddEditAccess, GradingDeleteAccess, loggedInUserId } = useGradingGroupListingState();
  const expandSearchRefBin = useRef(null);
  const history = useHistory();

  useEffect(() => {
    return () => {
      setgradingListing((prev) => ({
        ...prev,
        ListingData: [],
        pageIndex: 1,
        hasMore: false,
        searchText: '',
      }));
      dispatch(action.clearReducer());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (user?.role === 'User') {
      dispatch(userAction.fetchLogInRights({ section: 'all' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseDeleteModal = () => {
    setgradingListing((prevState) => ({
      ...prevState,
      deletedId: null,
      deleteModal: false,
      deleteMultipleModal: false,
    }));
  };

  const handleMultiDelete = () => {
    setgradingListing((prevState) => ({
      ...prevState,
      deleteMultipleModal: true,
    }));
  };

  const handleSingleDelete = (id) => {
    const array = [];
    array.push(id);
    setgradingListing((prevState) => ({
      ...prevState,
      deletedId: array,
      deleteModal: true,
    }));
  };

  const confirmDelete = async () => {
    const jsonString = JSON.stringify(gradingListingState.deletedId);
    const formattedString = jsonString.replace(/"/g, '"');
    const params = {
      groupIds: formattedString,
      loggedInUserId,
    };
    const response = await dispatch(action.DeleteGradingGroup(params, t));

    const reqObj = buildGradingListParams(gradingListingState, loggedInUserId, { pageIndex: 1 });
    dispatch(action.clearReducer());
    if (response) {
      setgradingListing((prevState) => ({
        ...prevState,
        ListingData: [],
        selectedGrading: [],
        pageIndex: 1,
        isPubParam: 1,
      }));
      await dispatch(action.fetchGradingGroupData(reqObj));
      handleCloseDeleteModal();
    }
  };

  const handleTemplateSearch = (value) => {
    setgradingListing((prev) => ({
      ...prev,
      searchText: value,
      searchLoaded: true,
    }));
  };
  const confirmDeleteMultiple = async () => {
    if (checkArray(gradingListingState?.selectedGrading)) {
      const usedInProduct = checkArray(gradingListingState.ListingData) && gradingListingState?.ListingData?.filter((ele) => ele?.development_orders?.length);
      const commonIds = usedInProduct?.filter((item) => gradingListingState.selectedGrading.includes(item._id));
      if (commonIds?.length) {
        commonIds.forEach((element) => {
          toasterMsg(`${element?.name} ${t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.IN_USE_CANNOT_DELETE')}`, 'danger');
        });
        handleCloseDeleteModal();
      } else {
        const jsonString = JSON.stringify(gradingListingState?.selectedGrading);
        const formattedString = jsonString.replace(/"/g, '"');
        const objDeleteMulti = {
          groupIds: formattedString,
          loggedInUserId,
        };
        const response = await dispatch(action.DeleteGradingGroup(objDeleteMulti, t));
        if (response) {
          const reqObj = buildGradingListParams(gradingListingState, loggedInUserId, { pageIndex: 1 });

          setgradingListing((prevState) => ({
            ...prevState,
            ListingData: [],
            selectedGrading: [],
            pageIndex: 1,
          }));
          dispatch(action.clearReducer());
          await dispatch(action.fetchGradingGroupData(reqObj));
          handleCloseDeleteModal();
        }
      }
    }
  };
  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };
  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container max-w-260">
          <h4 className="title w-xs-200px">{t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.GRADING_GROUP')}</h4>
        </div>
        <div className="action-icons-container">
          <div ref={expandSearchRefBin} className="common-expand-search">
            <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
              <span className="sr-only ">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH USER_INSTRUCTION')}</span>
              <span className="icon-Magnifying-Glass-Solid" />
            </button>
            <input
              type="text"
              className="form-control"
              onChange={(e) => handleTemplateSearch(e.target.value)}
              value={gradingListingState.searchText}
              autoComplete="off"
              placeholder={t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.SEARCH_PLACEHOLDER')}
            />
          </div>

          <GradingFilter />

          <div className="floting-actions">
            {GradingAddEditAccess && (
              <CustomTooltip placement="top" tooltipText={t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.ADD')}>
                <button aria-label="add" type="button" className="btn p-0" onClick={() => history.push('/libraries/gradings/add')}>
                  <i className="icon-Add" />
                </button>
              </CustomTooltip>
            )}
            {GradingDeleteAccess && (
              <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                <button
                  className="btn p-0"
                  type="button"
                  aria-label="delete"
                  onClick={() => handleMultiDelete()}
                  disabled={!gradingListingState?.selectedGrading?.length}
                >
                  <i className="icon-Delete" />
                </button>
              </CustomTooltip>
            )}
          </div>
        </div>
      </div>
      <PomTabs />
      {gradingListingState?.isLoading ? <Loader /> : <ListingTable handleSingleDelete={handleSingleDelete} />}
      {gradingListingState.deleteModal && (
        <ConfirmationPopup
          onOpen={gradingListingState.deleteModal}
          onConfirm={() => confirmDelete()}
          title={t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.DELETE_GRADING_GROUP')}
          message={t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.DELETE_CONFIRM_SINGLE')}
          toggle={() => handleCloseDeleteModal()}
        />
      )}
      {gradingListingState?.deleteMultipleModal && (
        <ConfirmationPopup
          onOpen={gradingListingState?.deleteMultipleModal}
          onConfirm={() => confirmDeleteMultiple()}
          title={t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.DELETE_GRADING_GROUP')}
          message={t('POMS.GRADING_GROUP_LISTING.GROUP_INDEX.DELETE_CONFIRM_SINGLE')}
          toggle={() => handleCloseDeleteModal()}
        />
      )}
    </>
  );
}

export default GradingListing;
